<template>
  <v-card id="acceptance-hazards" class="pa-4 mb-4">
    <div class="text-subtitle-1 font-weight-medium mb-2">
      {{ $t("acceptance.hazards.title") }}
    </div>
    <div class="d-flex flex-wrap">
      <v-checkbox
        v-for="hazard in hazards"
        :key="hazard.path"
        class="mr-4"
        density="compact"
        hide-details
        color="primary"
        :label="$t(hazard.label)"
        :model-value="values[hazard.path] === true"
        :readonly="readonly"
        :class="{ 'acceptance-unsaved': isHighlighted(hazard.path) }"
        @update:model-value="change(hazard.path, $event === true)"
      />
    </div>
    <v-text-field
      class="mt-2"
      variant="outlined"
      density="comfortable"
      :label="$t('acceptance.hazards.notes')"
      :model-value="values['hazards.notes']"
      :readonly="readonly"
      :bg-color="bg('hazards.notes')"
      maxlength="1000"
      hide-details
      @update:model-value="change('hazards.notes', $event)"
    />

    <!-- Any ticked hazard needs a quarantine decision before confirm. -->
    <v-sheet
      v-if="anyHazard"
      class="pa-3 mt-3 rounded"
      :color="
        values['quarantine.decision'] ? 'grey-lighten-4' : 'red-lighten-5'
      "
    >
      <div
        class="text-body-2 font-weight-medium"
        :class="{ 'text-red-darken-2': !values['quarantine.decision'] }"
      >
        {{ $t("acceptance.hazards.decision_required") }} *
      </div>
      <v-radio-group
        inline
        hide-details
        density="compact"
        :model-value="values['quarantine.decision']"
        :readonly="readonly"
        :class="{ 'acceptance-unsaved': isHighlighted('quarantine.decision') }"
        @update:model-value="change('quarantine.decision', $event)"
      >
        <v-radio
          value="quarantine"
          :label="$t('acceptance.quarantine_decisions.quarantine')"
        />
        <v-radio
          value="accept_into_yard"
          :label="$t('acceptance.quarantine_decisions.accept_into_yard')"
        />
      </v-radio-group>
    </v-sheet>
  </v-card>
</template>

<script>
const HAZARDS = [
  { path: "hazards.leaks", label: "acceptance.hazards.leaks" },
  { path: "hazards.fireOrFlood", label: "acceptance.hazards.fire_or_flood" },
  { path: "hazards.battery", label: "acceptance.hazards.battery" },
  { path: "hazards.missingParts", label: "acceptance.hazards.missing_parts" },
];

export default {
  name: "AcceptanceHazardsCard",
  props: {
    values: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
    highlight: { type: Array, default: () => [] },
  },
  emits: ["change"],
  data: () => ({ hazards: HAZARDS }),
  computed: {
    anyHazard() {
      return HAZARDS.some((hazard) => this.values[hazard.path] === true);
    },
  },
  methods: {
    isHighlighted(path) {
      return this.highlight.includes(path);
    },
    bg(path) {
      return this.isHighlighted(path) ? "amber-lighten-5" : undefined;
    },
    change(path, value) {
      this.$emit("change", path, value);
    },
  },
};
</script>

<style scoped>
.acceptance-unsaved {
  background-color: #fff8e1;
}
</style>
